import React from 'react';
import { TableCell, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const ResizeHandle = styled('div')(({ theme }) => ({
  position: 'absolute',
  right: -3,
  top: 0,
  bottom: 0,
  width: '7px',
  cursor: 'col-resize',
  userSelect: 'none',
  touchAction: 'none',
  zIndex: 10,
  backgroundColor: 'transparent',
  transition: 'background-color 0.2s',
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    opacity: 0.3,
  },
  '&:active': {
    backgroundColor: theme.palette.primary.main,
    opacity: 0.5,
  },
  // Visual indicator - always visible but subtle
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    width: '1px',
    backgroundColor: theme.palette.divider,
    opacity: 0.5,
  },
  '&:hover::before': {
    width: '2px',
    backgroundColor: theme.palette.primary.main,
    opacity: 1,
  }
}));

const ResizableTableCell = ({ 
  children, 
  width, 
  columnKey, 
  onResizeStart,
  resizable = true,
  className,
  isSticky = false,
  ...props 
}) => {
  const stickyStyles = isSticky ? {
    position: 'sticky',
    right: 0,
    zIndex: 3,
    backgroundColor: '#fafafa',
    boxShadow: '-2px 0 4px rgba(0,0,0,0.1)'
  } : {};
  
  return (
    <TableCell
      {...props}
      className={className}
      sx={{
        position: 'relative',
        width: width ? `${width}px` : 'auto',
        minWidth: width ? `${Math.min(width, 60)}px` : '60px',
        maxWidth: width ? `${width}px` : 'none',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        ...stickyStyles,
        ...props.sx
      }}
    >
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        position: 'relative',
        width: '100%'
      }}>
        {children}
        {resizable && onResizeStart && (
          <ResizeHandle
            onMouseDown={(e) => onResizeStart(e, columnKey)}
            onClick={(e) => e.stopPropagation()}
          />
        )}
      </Box>
    </TableCell>
  );
};

export default ResizableTableCell;